import { render, staticRenderFns } from "./addOtaDtu.vue?vue&type=template&id=2271207b&scoped=true"
import script from "./addOtaDtu.vue?vue&type=script&lang=js"
export * from "./addOtaDtu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2271207b",
  null
  
)

export default component.exports